// Slices/auth.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token : localStorage.getItem("token") || null,
  Employee_id: null,
  Employee_Name: null,
  Status: "Not Logged In",
  Message: "",
  registered: false,
  // loginpageActive: false,

};

const LoginSignUpSlice = createSlice({
  name: "LoginSignUpSlice",
  initialState,
  reducers: {
    signup(state, action) {
      console.log(action.payload);
      state.token = action.payload.token;
      state.Customer_userId = action.payload.userId;
      state.email = action.payload.email;
      state.name = action.payload.name;
      state.phone = action.payload.phone;

    },

    ImportUserDeatils(state, action) {
      state.Customer_userId = action.payload.Customer_userId;
      state.loginpageActive = action.payload.login;

      state.Unique_UserID = action.payload.Unique_UserID;
      state.registered = action.payload.registered;

      state.email = action.payload.email;
      state.name = action.payload.name;
      state.phone = action.payload.phone;
      state.userlogin = action.payload.userlogin;
      state.mobile_login_pageActive = action.payload.mobile_login_pageActive;

    },


    signIn(state, action) {

      state.Employee_Name = action.payload.Employee_Name;
      state.Employee_id = action.payload.Employee_id;
      state.Status = action.payload.Status;
      state.Message = action.payload.Message;
      state.token = action.payload.token;

    },
    logout(state) {
      // localStorage.clear();
      // state.Employee_Name = null;
      // state.Employee_id = null;
      // state.Status = "Not Logged In";

    },
    updateName(state, action) {
      console.log(action);
      state.name = action.payload;
    },
    updateNumber(state, action) {
      console.log(action);
      state.phone = action.payload;
    },
    updateEmail(state, action) {
      console.log(action);
      state.email = action.payload;
    },
    updateToken(state, action) {
      console.log(action);

      if(action.payload === "marchanttoken"){

        console.log(action.payload.role);
        console.log(action.payload.id);

        

        state.admintoken = action.payload.role;
        state.Merchant_userId = action.payload.id;

        // Merchant_userId


      }
      else if(action.payload === "superadmintoken"){

        state.superadmintoken = action.payload;


      }
      else if(action.payload === "token"){

        state.token = action.payload;

      }
      else{

        state.admintoken = null;
        state.superadmintoken = null;
        state.token = null;


      }
  
    },
    updateAdministrator(state, action) {
      console.log(action);

   
        

        state.Merchant_token = action.payload.role;
        state.Merchant_userId = action.payload.id;

        // Merchant_userId




        // state.superadmintoken = action.payload;



      // else if(action.payload === "token"){

      //   state.token = action.payload;

      // }
      // else{

      //   state.admintoken = null;
      //   state.superadmintoken = null;
      //   state.token = null;


      // }
  
    },
    activePages(state, action) {
      console.log(action);
      state.loginpageActive = action.payload.login;
    },

    activeMobileLoginPages(state, action) {
      console.log(action);
      state.mobile_login_pageActive = action.payload.login;
    },


    registered(state, action) {
      state.registered = action.payload;
    },

    addAddress(state, action) {
      console.log(action.payload);
      state.address = action.payload;
    },
    addSingleAddress(state, action) {
      state.address.unshift(action.payload);
    },
    modifyAddress(state, action) {
      console.log(action);
      const index = state.address.findIndex(
        (addr) => addr.id === action.payload.id
      );
      if (index !== -1) {
        state.address[index] = action.payload;
      }
    },
    removeAddress(state, action) {
      state.address = state.address.filter(
        (addr) => addr.id !== action.payload
      );
    },

    updatePan(state, action) {
      console.log(action);
      state.pan = action.payload;
    },
    updateAreaPin(state, action) {
      console.log(action);
      state.AreaPin = action.payload.pincode;
    },
    role(state, action){
      console.log(action);

      if(action.payload === "Marchant"){
        state.marchantlogin = true
      }
      else if(action.payload === "superadmin"){
        state.superadminlogin = true
      }
      else{
        console.log("role problem");
        
      }

     
      
    },
    setLat_Long_Location(state, action){


      state.Location ={


    Latitude : action.payload.Latitude,
    Longitude : action.payload.Longitude


      }

     
      
    },

  },
});

export const {
  role,
  updatePan,
  addSingleAddress,
  removeAddress,
  modifyAddress,
  addAddress,
  signup,
  signIn,
  activeMobileLoginPages,
  updateAdministrator,
  logout,
  updateNumber,
  updateToken,
  activePages,
  registered,
  updateEmail,
  updateName,
  updateAreaPin,
  setLat_Long_Location,
  ImportUserDeatils
} = LoginSignUpSlice.actions;

export const LoginSignUpSlicee = LoginSignUpSlice.reducer;
